export default "__VITE_ASSET__DP6ANr6S__"